"use strict";
/**
 * (C) Copyright 2023, Scaleton Labs LLC
 *
 * SPDX-License-Identifier: Apache-2.0
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssetType = void 0;
var AssetType;
(function (AssetType) {
    AssetType[AssetType["NATIVE"] = 0] = "NATIVE";
    AssetType[AssetType["JETTON"] = 1] = "JETTON";
})(AssetType || (exports.AssetType = AssetType = {}));
//# sourceMappingURL=AssetType.js.map